import React, { useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useNavigate } from "react-router-dom"; 
import { useTranslation } from "react-i18next";

const DelegacoesTable = ({ onSelect, searchTerm = "", delegations = []}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedDelegations, setSelectedDelegations] = useState([]);

  const filteredDelegations = delegations.filter((delegation) => {
    const search = searchTerm ? searchTerm.toLowerCase() : "";
    return (
      delegation.name?.toLowerCase().includes(search) ||
      delegation.location?.toLowerCase().includes(search)
    );
  });

  const handleCheckboxChange = (id) => {
    const isSelected = !selectedDelegations.includes(id);
    setSelectedDelegations((prev) =>
      isSelected ? [...prev, id] : prev.filter((item) => item !== id),
    );
    if (onSelect) {
      onSelect(id, isSelected);
    }
  };

  return (
    <>
      <table className="table table-hover table-borderless mb-0 mt-3 align-middle bg-surface">
        <thead style={{ borderBottom: "var(--border-thin)" }}>
          <tr>
            <th className="txt-main fw-semibold py-3 px-4 border-0" style={{ width: 40 }}></th>
            <th className="txt-main fw-semibold py-3 px-4 border-0">{t("components.DelegationTable.delegation")}</th>
            <th className="txt-main fw-semibold py-3 px-4 border-0">{t("components.DelegationTable.description")}</th>
            <th className="txt-main fw-semibold py-3 px-4 border-0">{t("components.DelegationTable.location")}</th>
            <th className="txt-main fw-semibold py-3 px-4 border-0">{t("components.DelegationTable.members")}</th>
            <th className="txt-main fw-semibold py-3 px-4 border-0">{t("components.DelegationTable.createdAt")}</th>
            <th className="txt-main fw-semibold py-3 px-4 border-0 text-center">{t("components.DelegationTable.actions")}</th>
          </tr>
        </thead>
        <tbody>
          {filteredDelegations.length > 0 ? (
            filteredDelegations.map((delegation) => {
              const memberCount = delegation.users ? delegation.users.length : 0;

              return (
                <tr key={delegation.id} style={{ borderBottom: "var(--border-thin)" }}>
                  <td className="py-3 px-4 border-0">
                    <div className="form-check m-0">
                      <input
                        className="form-check-input shadow-sm"
                        type="checkbox"
                        checked={selectedDelegations.includes(delegation.id)}
                        onChange={() => handleCheckboxChange(delegation.id)}
                      />
                    </div>
                  </td>
                  <td className="py-3 px-4 border-0 fw-semibold txt-main">
                    {delegation.name.length > 20
                      ? delegation.name.slice(0, 20) + "..."
                      : delegation.name}
                  </td>
                  <td className="py-3 px-4 border-0 txt-subtle">
                    {delegation.description && delegation.description.length > 30
                      ? delegation.description.slice(0, 30) + "..."
                      : delegation.description || t("components.DelegationTable.notAvailable")}
                  </td>
                  <td className="py-3 px-4 border-0 txt-subtle">
                    {delegation.location.length > 20
                      ? delegation.location.slice(0, 20) + "..."
                      : delegation.location}
                  </td>
                  
                  <td className="py-3 px-4 border-0 txt-main fw-semibold">
                    {memberCount}
                  </td>
                  
                  <td className="py-3 px-4 border-0 txt-subtle">
                    {delegation.created_at
                      ? delegation.created_at.slice(0, 10)
                      : ""}
                  </td>
                  <td className="py-3 px-4 border-0 text-center">
                    <button
                      className="btn btn-sm txt-inverse fw-semibold px-3"
                      style={{ backgroundColor: "var(--brand-primary)", borderRadius: "var(--btn-radius)" }}
                      onClick={() => navigate(`/organization/delegations/${delegation.id}`)}
                    >
                      {t("details")}
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" className="text-center py-5 txt-subtle bg-surface">
                {t("components.DelegationTable.noResults")}
              </td>
            </tr>
          )}
        </tbody>
      </table>




    </>
  );
};

export default DelegacoesTable;